import React from "react";

import { Login } from "../../../components/Login";

class LoginScreen extends React.Component {
  render() {
    return (
      <>
        <Login />
      </>
    );
  }
}

export default LoginScreen;
